import React, { useMemo } from 'react';
import { Box, Typography } from '@heycater/design-system';
import { BoxProps } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import Accordion from 'shared/components/Accordion';
import { FoodProgramH2 } from 'static_pages/foodProgram/Utils';
import Container from 'system/components/Container';

const LINE_BREAK_MARKER = '<1/>';
interface FAQ {
  title: string;
  description: string;
}

const FAQs = (props: BoxProps) => {
  const { t } = useTranslation('food_program');
  const faqs = useMemo(() => {
    const i18FAQs = t('faqs', { returnObjects: true });
    return Array.isArray(i18FAQs) ? (i18FAQs as FAQ[]) : [];
  }, [t]);

  return (
    <Container as="section" size="sm">
      <Box {...props}>
        <Box textAlign={'center'}>
          <FoodProgramH2 mb={4}>FAQs</FoodProgramH2>
        </Box>
        {faqs.map(({ title, description }) => (
          <Accordion
            key={title}
            summary={title}
            details={
              <Typography>
                {description.split(LINE_BREAK_MARKER).map((text) => (
                  <p key={text}>{text}</p>
                ))}
              </Typography>
            }
          />
        ))}
      </Box>
    </Container>
  );
};

export default FAQs;
